var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticStyle:{"color":"#ffffff"},attrs:{"color":"red"}},[_vm._v(" "+_vm._s(_vm.$t("nav_buttons.delete"))+" "),_c('v-icon',{staticClass:"ml-2"},[_vm._v("mdi-trash-can")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }